<template>
  <article class="layout-section -bg-primary">
    <div v-for="entry in wp.credits" :key="entry.title" class="card -bigger">
      <h3 class="card__title">{{ entry.title }}</h3>
      <div v-if="entry.content" class="rte" v-html="entry.content" />

      <a v-if="entry.link" :href="entry.link" class="link card__cta">
        {{ entry.linkLabel }}
        <SvgIcon id="action-arrow" />
      </a>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PartnersIndex',
  inject: ['wp']
}
</script>
